import useGoogleAnalytics from 'hooks/googleAnalytics/useGoogleAnalytics';

const GoogleAnalyticsHandler = () => {
  useGoogleAnalytics();
  return null;
};

export default GoogleAnalyticsHandler;
